import isEmpty from 'lodash/isEmpty';

import type {
  QueryModalTextFields,
  QueryStep
} from 'modules/insights/reports/types';

export const HASHTAGS = 'hashtags';
export const CHANNELS = 'channels';
export const HASHTAG = 'hashtag';
export const CHANNEL = 'channel';
export const ALL = 'all';
export const KEYWORDS = 'keywords';
export const TITLE = 'title';
export const IMPRESSIONS = 'impressions';
export const REACH = 'reach';
export const READY = 'ready';
export const IN_PROGRESS = 'in_progress';
export const NOT_FOUND = 'not_found';
export const NOT_FOUND_COLOR = '#d61600';

export const MAX_NUM_ITEMS = {
  hashtags: 10,
  channels: 100
};

export const KPI_DEFAULTS = {
  impressions: '35',
  reach: '25'
};

export const STEP_DETAILS = 'details';
export const STEP_CHANNELS = 'channels';

export const STEPS: Array<QueryStep> = [
  {
    key: STEP_DETAILS,
    index: 2
  },
  {
    key: STEP_CHANNELS,
    index: 3
  }
];

export const splitChannels = (
  value: string
): Array<string> => (
  ((value || '').trim() || null)?.split(/[\s,;]+/) ?? []
);

export const getErrorStatus = (
  textFields: QueryModalTextFields,
  key: 'title' | 'hashtags'| 'channels'
): boolean => {
  const value = textFields[key];

  return isEmpty(value) || value.length > MAX_NUM_ITEMS[key];
};
